import { render, staticRenderFns } from "./RecipeSteps.vue?vue&type=template&id=6fed48a5&scoped=true&"
import script from "./RecipeSteps.vue?vue&type=script&lang=js&"
export * from "./RecipeSteps.vue?vue&type=script&lang=js&"
import style0 from "./RecipeSteps.vue?vue&type=style&index=0&id=6fed48a5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fed48a5",
  null
  
)

export default component.exports